<template>
  <!-- <el-menu class="favorite" mode="vertical" router> -->
    <!-- <div class="favourite-count">
      <b>{{ favourites.children.length || 0 }}</b>/5
    </div> -->
    <!-- title="常用菜单" -->
    <el-menu-item-group>
      <sidebar-item
        :key="favourites.path"
        :item="favourites"
        :base-path="favourites.path"
        :common="true"
      />
    </el-menu-item-group>
  <!-- </el-menu> -->
</template>

<script>
import { SappModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
export default {
  components: {
    SidebarItem
  },
  data() {
    return {}
  },
  computed: {
    favourites() {
      return {
        iconCode: 'common-menu',
        code: '常用菜单',
        path: 'commonMenu',
        children: SappModule.favouriteMenu
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.favourite {
  position: relative;
  &-count {
    position: absolute;
    top: 16px;
    right: 10px;
    font-size: 13px;
    color: #c9c9c9;
    b {
      font-size: 16px;
      color: #666;
    }
  }
}
</style>
